import { TICK_INTERVAL } from '@/constants';

export default class Moving {
  constructor(reference, path) {
    this.path = path;
    this.step = 0;
    this.reference = reference;
  }

  get isArrived() {
    return this.step >= this.path.length - 1;
  }

  get currentCoord() {
    return this.path?.[this.step];
  }

  setPath(path) {
    this.path = path;
    this.step = 0;
  }

  move() {
    const { konvaNode } = this.reference;
    if (konvaNode && this.path && !this.isArrived) {
      this.step += 1;
      konvaNode.transformsEnabled('position');
      konvaNode.to({
        x: this.path[this.step][0],
        y: this.path[this.step][1],
        duration: TICK_INTERVAL / 1000,
      });
    }

    if (this.isArrived) {
      this.arrive();
    }
  }

  arrive() {
    if (this.reference.arrive) {
      this.reference.arrive();
    }
  }
}
